import React  from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { pure } from 'recompose'
import { Card, CardImage, CardContent, CardHeader } from 'modules/common/components/ui/Card'
import Button from 'modules/common/components/button/Button'
import withLocalized from 'modules/localization/withLocalized'
import { formatPrice } from 'utils/price-utils'

const BookingButton = styled(Button.withComponent(Link))`
  text-align: center;
  display: block;
  margin: auto 1rem 1rem;
`

const formatAddress = (showArea = false, address = '', area = {}, localized) => {
  if(!area.label || !showArea){
    return address
  }
  const areaText = localized(`areaselect.areas.${area.label}`)
  if(!address){
    return areaText
  }
  if(address.toLowerCase().endsWith(areaText.toLowerCase())){
    return address
  }
  return `${address}, ${areaText}`
}

const TeetimePrices = ({min, max, currency, localeConfig}) => {
  if(!min || !max || !currency){
    return null
  }
  if(min === max){
    return (
      <span>
        {`${formatPrice(min, currency, localeConfig('units.currency.locale'))}`}
      </span>
    )
  }
  return (
    <span>
      {`${formatPrice(min, currency, localeConfig('units.currency.locale'))} - ${formatPrice(max, currency, localeConfig('units.currency.locale'))}`}
    </span>
  )
}

const CourseCard = (props) => {
  const {
    id,
    name,
    fluid = false,
    active = false,
    marketing_pictures,
    address = '',
    onMouseOver = () => {},
    onMouseOut = () => {},
    activeOnHover = false,
    showArea = false,
    area = {},
    localized,
    localeConfig,
    golf18_courseid,
    tee_time_prices,
    className,
  } = props

  const linkHref = `/courses/${id}`

  const imageSrc = marketing_pictures instanceof Array && marketing_pictures.length > 0 ? marketing_pictures[0].formatted_large : 'https://s3-eu-west-1.amazonaws.com/btwebdata/default_images/default_image_course.jpg'

  const formattedAddress = formatAddress(showArea, address, area, localized)
  
  return (
    <Card fluid={fluid} activeOnHover={activeOnHover} active={active} onMouseOver={event => onMouseOver(props)} onMouseOut={onMouseOut} className={className}>
      <Link to={ linkHref }><CardImage src={imageSrc} /></Link>
      <CardContent>
        <CardHeader>
          <Link to={ linkHref }>{name}</Link>
        </CardHeader>
        <Link to={ linkHref }>
          { formattedAddress }
        </Link>
      </CardContent>
      {
          golf18_courseid && (
            <BookingButton to={ linkHref }>
              {localized('course.book_tee_time')} {tee_time_prices && <TeetimePrices localeConfig={localeConfig} {...tee_time_prices} />}
            </BookingButton>)
        }
    </Card>
  )
};

export default pure(withLocalized(CourseCard));



// WEBPACK FOOTER //
// ./src/modules/courses/components/CourseCard.js